<template>
<div>
    <div class="user-info-button">
            <div :class=this.usernameStyle>{{ username }}</div>
            <div class="user-info-button__avatar">
                <img @click="switchLogout()" :src="avatarUrl" :alt="username" class="user-info-button__avatar-image"/>
            </div>
    </div>
    <div v-show="ifshowLogout" class="logoutButton">
        <button @click="switchChatpage()">聊天记录</button>
        <button @click="goToBalance()">账户余额</button>
        <button @click="logout()">退出登录</button>
    </div>
</div>
  
</template>

<script>
import { getUserBalance } from '@/api/auth'

export default {
  name: 'UserInfoButton',
  data() {
    return {
      ifshowLogout: false,
      userBalance: 0,
    };
  },
  computed: {
    username() {
      return this.$store.state.username;
    },
    currentUserId() {
      return this.$store.state.userId;
    },
    ifHomepage() {
      return this.$route.path == '/' || this.$route.path == '/homepage'|| this.$route.path == '/productintro'|| this.$route.path == '/contact';
    },
    avatarUrl() {
      // 主页使用浅色头像
      if (this.ifHomepage) {
        return require('@/assets/images/userIconLight.png');
      }
      else {
        return require('@/assets/images/userIcon.png');
      }
    },
    usernameStyle() {
      return this.ifHomepage ? 'user-info-button__username_light' : 'user-info-button__username_dark';
    },  
  },
  mounted() {
    if (this.currentUserId) {
      this.fetchUserBalance();
    }
  },
  watch: {
    currentUserId(newVal) {
      if (newVal) {
        this.fetchUserBalance();
      }
    }
  },
  methods: {
    async fetchUserBalance() {
      try {
        const response = await getUserBalance(this.currentUserId);
        this.userBalance = response.current_tokens || 0;
      } catch (error) {
        console.error('获取用户余额失败:', error);
      }
    },
    logout() {
      this.$store.commit('setLoginStatus', false);
      this.$store.commit('setUsername', '');
      this.$store.commit('setUserId', '');
      this.ifshowLogout = false;
      if (this.$route.name != 'homepage')
        this.$router.push({ path: '/homepage' });
    },
    switchLogout() {
      this.ifshowLogout = !this.ifshowLogout;
      if (this.ifshowLogout && this.currentUserId) {
        this.fetchUserBalance(); // 显示下拉菜单时刷新余额
      }
    },
    switchChatpage() {
      if(this.$route.name != 'chat')
      {
        this.$router.push({ path: '/chat' });
      }
      this.ifshowLogout = false;
    },
    goToBalance() {
      if(this.$route.name != 'UserBalance')
      {
        this.$router.push({ path: '/balance' });
      }
      this.ifshowLogout = false;
    }
  },
};
</script>

<style scoped>
.user-info-button {

  display: flex;
  align-items: center;
  
}

.user-info-button__username_dark {
  margin-right: 10px;
  font-family: youSheBiaoTiHei;
  font-size: 20px;
}
.user-info-button__username_light {
  margin-right: 10px;
  color: #fff;
  font-family: youSheBiaoTiHei;
  font-size: 20px;
}

.user-info-button__avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
  cursor: pointer;
}

.user-info-button__avatar-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.logoutButton{
    display: flex;
    flex-direction: column;
    position: fixed ;
    top: 60px ;
    right: 10px;
    background: white;
    box-shadow:rgba(0, 0, 0, 0.2) 2px 2px 4px;
    border-radius: 5px;
    padding: 5px;
    font-family:youSheBiaoTiHei;
    z-index: 10;
    min-width: 160px;
}
.balance-info {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  margin-bottom: 8px;
  background-color: #f5f7fa;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.balance-info:hover {
  background-color: #e6f7ff;
}

.balance-label {
  font-size: 12px;
  color: #666;
  margin-right: 8px;
}

.balance-value {
  font-size: 14px;
  font-weight: bold;
  color: #409eff;
  margin-right: 4px;
}

.balance-unit {
  font-size: 12px;
  color: #999;
}

.logoutButton button {
  display: block;
  width: 100%;
  padding: 8px 12px;
  margin-bottom: 5px;
  background-color: transparent;
  border: none;
  text-align: left;
  cursor: pointer;
  border-radius: 4px;
  transition: background-color 0.3s;
}

.logoutButton button:hover {
  background-color: #f5f5f5;
}

.logoutButton button:last-child {
  margin-bottom: 0;
}
</style>
